module.exports = __webpack_public_path__ + "img/skirt.be5030ca.webp";